export default class DataValidator {
    static validateRequired = v => !!v
        || "Поле обязательно для заполнения";

    static validateLength = (v, minLength) => v.length >= minLength
        || `Строка должна быть не короче ${minLength} символов`;

    static validateEmail = v => (/.+@.+\..+/.test(v))
        || "Должен быть корректный email";

    static getStringRules(minLength) {
        return [
            v => this.validateRequired(v),
            v => this.validateLength(v, minLength)
        ];
    }

    static getLoginRules() {
        return [
            v => this.validateRequired(v),
            v => v.length >= 2
                || "Логин должен быть не короче 2 символов"
        ];
    }

    static getEmailRules() {
        return [
            v => this.validateRequired(v),
            v => this.validateEmail(v)
        ];
    }

    static getPasswordRules(passwordOptions) {
        const requiredLength = passwordOptions?.requiredLength ?? 0;
        const requireLowercase = passwordOptions?.requireLowercase ?? false;
        const requireUppercase = passwordOptions?.requireUppercase ?? false;
        const requireDigit = passwordOptions?.requireDigit ?? false;

        return [
            v => this.validateRequired(v),
            v => v.length >= requiredLength
                || `Пароль должен быть не короче ${requiredLength} символов`,
            v => !requireLowercase || v.toUpperCase() !== v
                || "Пароль обязательно должен содержать букву в нижнем регистре",
            v => !requireUppercase || v.toLowerCase() !== v
                || "Пароль обязательно должен содержать букву в верхнем регистре",
            v => requireDigit || v.split("").some(c => Number.isInteger(+c))
                || "Пароль обязательно должен содержать цифру"
        ];
    }

    static getPasswordConfirmationRules(otherValue, passwordOptions) {
        return [
            ...this.getPasswordRules(passwordOptions),
            value => otherValue === value || "Пароли должны совпадать"
        ];
    }
}